import React from 'react';
import adminStyles from '../styles.module.css';

function AdminNotification() {
    return (
        <div className={adminStyles.mainSection}>
            Under Development
        </div>
    )
}

export default AdminNotification;
